import { Typography } from 'packages/radiant-react/typography';
import styles from './styles.module.scss';

export interface CommonInputProps {
  onChange: (color: string | undefined) => void;
  value: string | undefined;
  name: string;
  info?: string;
  range?: {
    max: number;
    min: number;
  };
}

export const InputLabel = ({ name, info }: { name: string; info?: string }) => {
  return (
    <Typography
      variant="body-normal"
      className={styles.inputLabel}
      tooltipConfig={{
        dataTooltipContent: info || name,
        dataTooltipPosition: 'top',
        showTooltipOnlyOnEllipsis: false,
      }}
    >
      {name}
    </Typography>
  );
};
